import React, { useState } from 'react';
import axios from 'axios';
import { Cookies } from "../../../../index.js";
import { alert_error, alert_success } from "../../../../AppContext";
import Ticket_holder from '../../../../order/orders/ticket_holder.jsx';
import { update_amount_orders, update_money_orders, update_discount_orders, update_comments_orders } from '../../../../order/orders/actions.js';
import { useSelector, useDispatch } from 'react-redux';
// orders_vip.jsx
// Component moved out from Orders_main — logic & classNames preserved.
// Now also contains nutxuly, nutorder state and handleSubmit (plus testFunction & loimatroi)

export default function OrdersVip({ services_info, set_accounts_product }) {
    const [nutxuly, setnutxuly] = useState(0);
    const [nutorder, setnutorder] = useState('💚 Nhận ngay');
    const discount_orders = useSelector(state => state.discount_orders);
    const amount_orders = useSelector(state => state.amount_orders);
    const comments_orders = useSelector(state => state.comments_orders);
    const dispatch = useDispatch();

    const loimatroi = (error) => {
        alert_error(error);
        setnutorder("Thử lại xem");
        setnutxuly(0);
    };
    const set_amount_orders = (value) => {
        dispatch(update_amount_orders(value));
    };
    const set_money_orders = (value) => {
        dispatch(update_money_orders(value));
    };
    const set_discount_orders = (value) => {
        dispatch(update_discount_orders(value));
    };
    const set_comments_orders = (value) => {
        dispatch(update_comments_orders(value));
    };

    function laydulieu() {
        const apikey = Cookies.get("apikey");
        axios
            .post("https://hust.media/api/wallet/laychietkhau.php?apikey=" + apikey)
            .then((response) => set_discount_orders(response.data))
            .catch((error) => console.log(error));
    }
    function testFunction(response) {
        const info = response.data;
        const orderok = info.trans_id;
        const error = info.error;
        setnutorder("đặt tiếp luôn nào");
        setnutxuly(0);
        if (error) {
            alert_error(info.error);
        } else if (orderok) {
            alert_success('Thankiuu Bạn là người thứ ' + orderok + ' ủng hộ Hust Media');
            set_accounts_product(info);
        }
        else {
            alert_error('Lỗi không xác định vui lòng liên hệ admin');
        }

        if (info.redirect != null && info.redirect != "") {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        }
    }

    function handleSubmit(event) {
        event && event.preventDefault();
        setnutxuly(0);
        const apikey = Cookies.get("apikey");
        const national_market = Cookies.get("national_market");

        setnutxuly(1);
        setnutorder("Please wait a moment 😊");
        if (!services_info || !services_info.id) {
            alert("Please điền đầy đủ thông tin");
            setnutxuly(0);
            setnutorder("điền đủ thông tin");
            return;
        }
        const postData = {
            action: 'buyProduct',
            key: apikey,
            quantity: amount_orders,
            national_market: national_market,
            service: services_info.id
        };
        if (comments_orders) {
            postData.comments = comments_orders;
        }
        axios
            .post("https://hust.media/api/v3", postData)
            .then((response) => testFunction(response))
            .catch((error) => loimatroi(error));
    }

    function tinhgia2(amountok, rate) {
        const giagiamok = rate * amountok * discount_orders / 100;
        const giaok = rate * amountok - giagiamok;
        set_money_orders(giaok);
    }
    function tinhgia(amountok) {
        tinhgia2(amountok, services_info.accounts_price);
    }


    return (
        <>
            <div className="mt-3 flex flex-col gap-3">

                {/* Input */}
                <div className="flex w-full flex-col gap-1">
                    <div className="text-sm font-medium text-gray-700">Số lượng</div>
                    <div className="input-group flex-nowrap w-full">
                        <input
                            onChange={(e) => {
                                set_amount_orders(e.target.value);
                                tinhgia(e.target.value);
                            }}
                            value={amount_orders}
                            type="text"
                            className="form-control mb-0 w-full"
                            placeholder="Nhập số lượng mong muốn"
                        />
                    </div>
                </div>

                {/* Note */}
                <div className="flex w-full flex-col gap-1">
                    <div className="text-sm font-medium text-gray-700">Ghi chú</div>
                    <div className="input-group flex-nowrap w-full">
                        <input
                            onChange={(e) => set_comments_orders(e.target.value)}
                            value={comments_orders}
                            type="text"
                            className="form-control mb-0 w-full"
                            placeholder="Nhập ghi chú (nếu có)"
                        />
                    </div>
                </div>

                {/* Button */}
                <div className="flex w-full">
                    <button
                        disabled={nutxuly == 1}
                        onClick={handleSubmit}
                        className="flex w-full items-center justify-center bg-purple-400 hover:bg-purple-300 rounded-3xl py-2 dark:bg-slate-800 dark:text-white"
                    >
                        {nutxuly == 1 && <div className="spinner-border" role="status"></div>}
                        <span className="text-base font-medium text-white">{nutorder}</span>
                        <div className="text-xl ml-2">{'\u27A4'}</div>
                    </button>
                </div>

            </div>
            <div className="mt-2" >
                <Ticket_holder />
            </div>
        </>
    );
}
